import React, { Component } from "react";
import {
  Box,
  Button,
  Card,
  CardActions,
  Typography,
  Modal,
  Tooltip,
  IconButton,
  Stack,
  Chip,
  Divider,
  alpha,
  styled,
  tooltipClasses,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RefreshIcon from "@mui/icons-material/Refresh";
import DeleteIcon from "@mui/icons-material/Delete";
import UndoIcon from "@mui/icons-material/Undo";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import MergeIcon from "@mui/icons-material/Merge";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import GroupsIcon from "@mui/icons-material/Groups";
import PersonIcon from "@mui/icons-material/Person";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import "./TeamCollaboration.css";
import { toast, ToastContainer } from "react-toastify";
import Loader from "../../utils/loader";
import { withRouter } from "react-router-dom";
import TeamCollaborationServices from "../../services/teamCollbarationServices";
import { connect } from "react-redux";
import { convertFromRaw } from "draft-js";
import { stateToHTML } from "draft-js-export-html";
import { option_ } from "../Editor/utilize";
import ReactHtmlParser from "react-html-parser";
import Diff from "../ReactDiff";
import isEmptyObject from "../../utils/isEmptyObject";
import swal from "sweetalert";
import userService from "../../services/userService";
import ReactTour from "../ReactTour";
import { addUserLogs } from "../../services/userLogServices";
import {
  getBotAccess,
  BOT_TYPES,
  getBotGuideSettings,
  recordBotGuideAutoOpen,
} from "../settingsNew";
// ── Tour Bot ──────────────────────────────────────────────────────────────────
import TeamCollaborationTourBot from "../../bot/teamCollabrationBot";

// ── Styled Light Tooltip ──────────────────────────────────────────────────────
const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#ffffff",
    color: COLORS.text.blue,
    boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
    fontSize: 12,
    fontWeight: 500,
    borderRadius: 8,
    padding: "6px 12px",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#ffffff",
  },
}));

// ── Color Palette ─────────────────────────────────────────────────────────────
const COLORS = {
  primary: {
    main: "#1976d2",
    light: "#e3f2fd",
    medium: "#90caf9",
    dark: "#1565c0",
    contrast: "#ffffff",
  },
  secondary: {
    main: "#9c27b0",
    light: "#f3e5f5",
    medium: "#ce93d8",
    dark: "#7b1fa2",
    contrast: "#ffffff",
  },
  success: {
    main: "#2e7d32",
    light: "#c8e6c9",
    medium: "#81c784",
    dark: "#1b5e20",
    contrast: "#ffffff",
  },
  error: {
    main: "#d32f2f",
    light: "#ffcdd2",
    medium: "#ef5350",
    dark: "#c62828",
    contrast: "#ffffff",
  },
  warning: {
    main: "#ed6c02",
    light: "#ff9800",
    medium: "#ffb74d",
    dark: "#e65100",
    contrast: "#ffffff",
  },
  info: {
    main: "#0288d1",
    light: "#bbdefb",
    medium: "#64b5f6",
    dark: "#01579b",
    contrast: "#ffffff",
  },
  background: {
    main: "#f5f7fa",
    card: "#ffffff",
    paper: "#f8f9fa",
    light: "#fafafa",
  },
  text: {
    primary: "#000000",
    secondary: "#424242",
    blue: "#1976d2",
    disabled: "#9e9e9e",
    white: "#ffffff",
  },
  border: {
    light: "#e0e0e0",
    medium: "#bdbdbd",
    dark: "#757575",
  },
  actionButtons: {
    accept: "#4caf50",
    reject: "#f44336",
    merge: "#2196f3",
    undo: "#ff9800",
    reset: "#ff5722",
    complete: "#009688",
  },
};

// ─────────────────────────────────────────────────────────────────────────────
export class TeamCollaboration extends Component {
  state = {
    userProfileColor: [],
    isAccepted: "",
    username: "",
    display_picture: "",
    originalDocument: "",
    mergeDocuments: [],
    htmlContent: null,
    compareID: "",
    compareDP: "",
    compareUserID: "",
    compareName: "",
    compareRAW: null,
    comapreContent: null,
    leftCell: [],
    rightCell: [],
    changeCount: 0,
    merging: false,
    loading: true,
    reactTour: false,
    tourChange: false,
    showTeamBot: true,
    teamBotAutoStart: false,
    modalOpen: false,
    fullscreenMode: null, // 'owner' | 'collaborator' | null
    steps1: [
      {
        selector: ".reactour-1",
        content:
          "Displays all the collaborators for current document. Click to view and manage collaborators",
        position: "left",
      },
      {
        selector: ".reactour-2",
        content: () => (
          <div>
            <p>Current document content</p>
            <b>Legend :</b>
            <p>
              <span
                style={{
                  backgroundColor: COLORS.success.light,
                  padding: "2px 4px",
                  borderRadius: "2px",
                  color: COLORS.success.dark,
                }}
              >
                Green Highlight
              </span>{" "}
              = New content from collaborator
            </p>
            <p>
              <span
                style={{
                  backgroundColor: COLORS.error.light,
                  padding: "2px 4px",
                  borderRadius: "2px",
                  color: COLORS.error.dark,
                }}
              >
                Red Highlight
              </span>{" "}
              = Content to be removed
            </p>
          </div>
        ),
        position: "right",
      },
      {
        selector: ".reactour-3",
        content: "Collaborator's document content",
        position: "left",
      },
      {
        selector: ".reactour-4",
        content: "Reset all changes made during collaboration",
        position: "top",
      },
      {
        selector: ".reactour-5",
        content: "Save all changes to current document",
        position: "top",
      },
    ],
    steps2: [
      {
        selector: ".reactour-1",
        content:
          "Displays all the collaborators for current document. Click to view and manage collaborators",
        position: "left",
      },
      {
        selector: ".reactour-2",
        content: () => (
          <div>
            <p>Current document content</p>
            <b>Legend :</b>
            <p>
              1.{" "}
              <span
                style={{
                  backgroundColor: COLORS.success.light,
                  padding: "2px 4px",
                  borderRadius: "2px",
                  color: COLORS.success.dark,
                }}
              >
                Green Highlight
              </span>{" "}
              = New content
            </p>
            <p>
              2.{" "}
              <span
                style={{
                  backgroundColor: COLORS.error.light,
                  padding: "2px 4px",
                  borderRadius: "2px",
                  color: COLORS.error.dark,
                }}
              >
                Red Highlight
              </span>{" "}
              = Content to be removed
            </p>
            <p>3. Normal text = Matching content</p>
          </div>
        ),
        position: "right",
      },
      {
        selector: ".reactour-3",
        content: "Collaborator's document content",
        position: "left",
      },
      {
        selector: ".reactour-4",
        content: "Collaboration toolbar",
        position: "top",
      },
      {
        selector: ".reactour-5",
        content: "Accept all changes from collaborator",
        position: "top",
      },
      {
        selector: ".reactour-6",
        content: "Reject all changes from collaborator",
        position: "top",
      },
      {
        selector: ".reactour-7",
        content: "Merge all content from collaborator",
        position: "top",
      },
      {
        selector: ".reactour-8",
        content: "Reset all changes",
        position: "top",
      },
      {
        selector: ".reactour-9",
        content: "Save all changes",
        position: "top",
      },
    ],
  };

  // ── Lifecycle ───────────────────────────────────────────────────────────────
  // async componentDidMount() {
  //   const isTeamCollabActive = getBotAccess(BOT_TYPES.TEAM_COLLAB);
  //   const guideSettings = getBotGuideSettings(BOT_TYPES.TEAM_COLLAB);
  //   this.setState({
  //     showTeamBot: isTeamCollabActive,
  //     teamBotAutoStart: guideSettings.shouldAutoOpen,
  //   });
  //   window.addEventListener("botAccessChanged", this.handleBotAccessChange);

  //   let { document } = this.props.location.state;
  //   let { userProfileColor } = this.props.location.state;
  //   this.setState({ userProfileColor });

  //   let { currentUser } = this.props;
  //   let data;
  //   if (currentUser && !isEmptyObject(currentUser)) {
  //     data = { ...currentUser };
  //   } else {
  //     let user = await userService.getProfile();
  //     data = { ...user.data };
  //   }

  //   const onlyDocumentData = document.onlyDocumentContent;
  //   let transformedContent = onlyDocumentData.replace(
  //     /<p>(.*?)<\/p>/g,
  //     (match, content) => {
  //       return `${content.trim()}\n`;
  //     },
  //   );
  //   const textWithNewlines = transformedContent.replace(/<[^>]*>/g, "");
  //   const finalText = textWithNewlines.replace(/&nbsp;/g, " ");

  //   const formattedText = {
  //     blocks: [
  //       {
  //         key: "9ukr0",
  //         text: finalText,
  //         type: "unstyled",
  //         depth: 0,
  //         inlineStyleRanges: [],
  //         entityRanges: [],
  //         data: {},
  //       },
  //     ],
  //     entityMap: {},
  //   };

  //   const jsonText = JSON.stringify(formattedText);
  //   document.onlyDocumentContent = jsonText;

  //   this.setState(
  //     {
  //       originalDocument: document,
  //       username: data.username,
  //       display_picture: data.display_picture,
  //     },
  //     async () => {
  //       await this.convertToHtml(
  //         this.state.originalDocument.onlyDocumentContent,
  //         true,
  //       );
  //       await this.getCollabDocuments();
  //       await this.cellDetails();
  //     },
  //   );
  // }

  async componentDidMount() {
  const isTeamCollabActive = getBotAccess(BOT_TYPES.TEAM_COLLAB);
  const guideSettings = getBotGuideSettings(BOT_TYPES.TEAM_COLLAB);
  this.setState({
    showTeamBot: isTeamCollabActive,
    teamBotAutoStart: guideSettings.shouldAutoOpen,
  });
  window.addEventListener("botAccessChanged", this.handleBotAccessChange);

  let { document } = this.props.location.state;
  let { userProfileColor } = this.props.location.state;
  this.setState({ userProfileColor });

  let { currentUser } = this.props;
  let data;
  if (currentUser && !isEmptyObject(currentUser)) {
    data = { ...currentUser };
  } else {
    let user = await userService.getProfile();
    data = { ...user.data };
  }

  const onlyDocumentData = document.onlyDocumentContent;
  
  // Check if the content is already in the correct format
  let formattedText;
  try {
    const parsed = JSON.parse(onlyDocumentData);
    if (parsed.blocks && Array.isArray(parsed.blocks)) {
      // Already in correct format
      formattedText = parsed;
    } else {
      // Need to format
      throw new Error("Invalid format");
    }
  } catch (e) {
    // Convert HTML to proper format
    let transformedContent = onlyDocumentData.replace(
      /<p>(.*?)<\/p>/g,
      (match, content) => {
        return `${content.trim()}\n`;
      },
    );
    const textWithNewlines = transformedContent.replace(/<[^>]*>/g, "");
    const finalText = textWithNewlines.replace(/&nbsp;/g, " ");

    formattedText = {
      blocks: [
        {
          key: "9ukr0",
          text: finalText,
          type: "unstyled",
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
      ],
      entityMap: {},
    };
  }

  const jsonText = JSON.stringify(formattedText);
  document.onlyDocumentContent = jsonText;

  this.setState(
    {
      originalDocument: document,
      username: data.username,
      display_picture: data.display_picture,
    },
    async () => {
      await this.convertToHtml(
        this.state.originalDocument.onlyDocumentContent,
        true,
      );
      await this.getCollabDocuments();
      await this.cellDetails();
    },
  );
}

  // ── Fullscreen toggles ──────────────────────────────────────────────────────
  toggleOwnerFullscreen = () => {
    this.setState((prevState) => ({
      fullscreenMode: prevState.fullscreenMode === "owner" ? null : "owner",
    }));
  };

  toggleCollaboratorFullscreen = () => {
    this.setState((prevState) => ({
      fullscreenMode:
        prevState.fullscreenMode === "collaborator" ? null : "collaborator",
    }));
  };

   handleBotAccessChange = (event) => {
    const { botType, status } = event.detail;

    if (botType === BOT_TYPES.TEAM_COLLAB) {
      this.setState({
        showTeamBot: status,
        teamBotAutoStart: getBotGuideSettings(BOT_TYPES.TEAM_COLLAB).shouldAutoOpen,
      });
    }
  };
  // ── Refresh ─────────────────────────────────────────────────────────────────
  handleRefresh = async () => {
    try {
      this.setState({ loading: true });
      await this.getCollabDocuments();
      await this.cellDetails();
      toast.success("Collaboration refreshed");
      this.setState({ loading: false });
    } catch (err) {
      this.setState({ loading: false });
      toast.error("Refresh failed ❌");
      console.log(err);
    }
  };

  handleBack = () => {
    this.props.history.push("/mydocuments");
  };

  // ── Cell alignment ──────────────────────────────────────────────────────────
  cellDetails = async () => {
    let { originalDocument, compareRAW } = this.state;
    let OGeditor = await JSON.parse(originalDocument.onlyDocumentContent);
    let collabEditor = await JSON.parse(compareRAW);
    let leftCell = await JSON.parse(originalDocument.onlyDocumentContent)
      .blocks;
    let rightCell = await JSON.parse(compareRAW).blocks;

    if (leftCell.length < rightCell.length) {
      for (let i = leftCell.length; i < rightCell.length; i++) {
        let fakeCell = {
          key: Math.random().toString(20).substr(2, 5),
          text: "",
          type: "unstyled",
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
          done: false,
          reject: false,
        };
        await leftCell.push(fakeCell);
      }
      OGeditor.blocks = leftCell;
    } else {
      for (let i = rightCell.length; i < leftCell.length; i++) {
        let fakeCell = {
          key: Math.random().toString(20).substr(2, 5),
          text: "",
          type: "unstyled",
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
          done: false,
          reject: false,
        };
        rightCell.push(fakeCell);
      }
      collabEditor.blocks = rightCell;
    }

    this.setState({
      OGeditor: OGeditor,
      collabEditor: collabEditor,
      leftCell: leftCell,
      rightCell: rightCell,
    });
  };

  // ── Fetch collaborator docs ─────────────────────────────────────────────────
  getCollabDocuments = async () => {
    let userId = sessionStorage.getItem("userId");
    let doc = this.state.originalDocument;
    let data = await TeamCollaborationServices.getCollabDocuments(
      doc.pendingDocuments,
      userId,
    );

    if (data.status === 200) {
      let mergedDocs = data.data;
      const onlyDocumentData = mergedDocs[0].onlyDocumentContent;

      let transformedContent = onlyDocumentData.replace(
        /<p>(.*?)<\/p>/g,
        (match, content) => {
          return `${content.trim()}\n`;
        },
      );

      const textWithoutHTML = transformedContent.replace(/<[^>]*>/g, "");
      const finalText = textWithoutHTML.replace(/&nbsp;/g, " ");

      const formattedText = {
        blocks: [
          {
            key: "9ukr0",
            text: finalText,
            type: "unstyled",
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {},
          },
        ],
        entityMap: {},
      };

      const jsonText = JSON.stringify(formattedText);
      mergedDocs[0].onlyDocumentContent = jsonText;

      this.setState(
        {
          mergeDocuments: mergedDocs,
          compareID: mergedDocs[0]._id,
          compareDP: mergedDocs[0].editor.display_picture,
          compareUserID: mergedDocs[0].editor._id,
          compareName: mergedDocs[0].editor.username,
          compareRAW: mergedDocs[0].onlyDocumentContent,
          loading: false,
        },
        () => this.convertToHtml(mergedDocs[0].onlyDocumentContent, false),
      );
    } else {
      console.log(data.message);
    }
  };

  // convertToHtml = (data, original) => {
  //   const storedState = JSON.parse(data);
  //   const contentState = convertFromRaw(storedState);
  //   let editorContentHtml = stateToHTML(contentState, option_);
  //   let htmlContent = ReactHtmlParser(editorContentHtml);
  //   if (original === true) {
  //     this.setState({ htmlContent });
  //   } else {
  //     this.setState({ comapreContent: htmlContent });
  //   }
  // };
convertToHtml = (data, original) => {
  try {
    let storedState;
    
    // Handle different data formats that might come from the backend
    if (typeof data === 'string') {
      storedState = JSON.parse(data);
    } else {
      storedState = data;
    }
    
    // Ensure blocks array exists
    if (!storedState.blocks) {
      console.error("Invalid document structure:", storedState);
      return;
    }
    
    const contentState = convertFromRaw(storedState);
    let editorContentHtml = stateToHTML(contentState, option_);
    let htmlContent = ReactHtmlParser(editorContentHtml);
    
    if (original === true) {
      this.setState({ htmlContent });
    } else {
      this.setState({ comapreContent: htmlContent });
    }
  } catch (error) {
    console.error("Error converting to HTML:", error);
    // Fallback to empty content
    if (original === true) {
      this.setState({ htmlContent: [] });
    } else {
      this.setState({ comapreContent: [] });
    }
  }
};
  compareData = async (document) => {
    this.setState(
      {
        changeCount: 0,
        merging: false,
        compareID: document._id,
        compareDP: document.editor.display_picture,
        compareUserID: document.editor._id,
        compareName: document.editor.username,
        compareRAW: document.onlyDocumentContent,
      },
      async () => {
        await this.convertToHtml(document.onlyDocumentContent, false);
        await this.cellDetails();
      },
    );
  };

  // ── Accept / Reject / Merge / Undo ─────────────────────────────────────────
  getOriginalBlockText = (index) => {
    const { originalDocument } = this.state;
    const originalBlocks = JSON.parse(originalDocument.onlyDocumentContent).blocks;
    return originalBlocks[index]?.text || "";
  };

  onAccept = (key, text) => {
    const { OGeditor, changeCount } = this.state;
    const updatedBlocks = OGeditor.blocks.map((block) =>
      block.key === key
        ? {
            ...block,
            text: text || "",
            done: true,
            reject: false,
          }
        : block,
    );

    this.setState({
      OGeditor: { ...OGeditor, blocks: updatedBlocks },
      leftCell: updatedBlocks,
      changeCount: changeCount + 1,
      merging: true,
      isAccepted: "accepted",
    });
  };

  onReject = (key, text) => {
    const { OGeditor, changeCount } = this.state;
    const updatedBlocks = OGeditor.blocks.map((block, index) =>
      block.key === key
        ? {
            ...block,
            text: this.getOriginalBlockText(index),
            reject: true,
            done: true,
          }
        : block,
    );

    this.setState({
      OGeditor: { ...OGeditor, blocks: updatedBlocks },
      leftCell: updatedBlocks,
      changeCount: changeCount + 1,
      merging: true,
      isAccepted: "rejected",
    });
  };

  onBoth = (key, text) => {
    const { OGeditor, changeCount } = this.state;
    const updatedBlocks = OGeditor.blocks.map((block) =>
      block.key === key
        ? {
            ...block,
            text: `${block.text || ""}${text || ""}`,
            reject: false,
            done: true,
          }
        : block,
    );

    this.setState({
      OGeditor: { ...OGeditor, blocks: updatedBlocks },
      leftCell: updatedBlocks,
      changeCount: changeCount + 1,
      merging: true,
      isAccepted: "accepted",
    });
  };

  undoChange = async (key, text) => {
    const { OGeditor, originalDocument, changeCount } = this.state;
    let og = await JSON.parse(originalDocument.onlyDocumentContent);
    for (let i = 0; i < OGeditor.blocks.length; i++) {
      if (OGeditor.blocks[i].key === key) {
        if (i > og.blocks.length - 1) {
          OGeditor.blocks[i].text = "";
        } else {
          OGeditor.blocks[i].text = og.blocks[i].text;
        }
        OGeditor.blocks[i].reject = false;
        OGeditor.blocks[i].done = false;
      }
    }
    this.setState(
      {
        OGeditor,
        leftCell: OGeditor.blocks,
        changeCount: changeCount - 1,
        merging: true,
      },
      () => {
        if (changeCount - 1 === 0) this.setState({ merging: false });
      },
    );
  };

  resetChanges = async () => {
    this.setState({ changeCount: 0 });
    let document = {
      _id: this.state.compareID,
      editor: {
        _id: this.state.compareUserID,
        display_picture: this.state.compareDP,
        username: this.state.compareName,
      },
      onlyDocumentContent: this.state.compareRAW,
    };
    await this.compareData(document);
  };

  removeCollaborater = async (doc) => {
    swal({
      title: "Remove Collaborator",
      text: "Are you sure you want to remove this collaborator?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (removeCollab) => {
      if (removeCollab) {
        let userId = sessionStorage.getItem("userId");
        let data = await TeamCollaborationServices.removeCollaborater(
          doc._id,
          userId,
        );
        if (data.status === 200) {
          toast.success(data.message);
          setTimeout(() => {
            this.props.history.push({ pathname: "/mydocuments" });
          }, 1000);
        } else {
          toast(data.message);
        }
      }
    });
  };

  convertTextToHtml = (text) => {
    const paragraphs = text.split("\n");
    const htmlContent = paragraphs.map((paragraph) => {
      const paragraphWithBreaks = paragraph.replace(/\n{2,}/g, "<br><br>");
      return `<p>${paragraphWithBreaks}</p>`;
    });
    return htmlContent.join("");
  };

  mergeDocument = async () => {
    let { originalDocument, compareID, compareUserID, OGeditor } = this.state;

    const reviewedBlocks = OGeditor.blocks.map((block) => ({ ...block }));
    const cleanedBlocks = reviewedBlocks.map(
      ({ done, reject, ...blockWithoutFlags }) => ({
        ...blockWithoutFlags,
      }),
    );
    const contentStateRaw = {
      blocks: cleanedBlocks,
      entityMap: OGeditor.entityMap || {},
    };
    const finalContentState = convertFromRaw(contentStateRaw);
    const finalOnlyDocumentContent = stateToHTML(finalContentState, option_);
    // const finalOnlyDocumentContent = JSON.stringify(contentStateRaw);
    const overallDecision = reviewedBlocks.some(
      (block) => block.done && block.reject === false,
    )
      ? "accepted"
      : "rejected";

    let userId = sessionStorage.getItem("userId");
    const formattedDocumentContent = JSON.stringify(contentStateRaw);

    let doc = {
      originalID: originalDocument._id,
      draftID: compareID,
      draftUserId: compareUserID,
      formattedDocumentContent: formattedDocumentContent,
      onlyDocumentContent: finalOnlyDocumentContent,
        // onlyDocumentContent: JSON.stringify(contentStateRaw),
      userId: userId,
      isAccepted: overallDecision,
    };

    swal({
      title: "Merge Document",
      text: "Are you sure you want to merge this document?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (mergeDoc) => {
      if (mergeDoc) {
        let data = await TeamCollaborationServices.mergeDocument(doc);
        if (data.status === 200) {
          toast.success(data.message);
          const data1 = {
            userId: sessionStorage.getItem("userId"),
            organizationId: sessionStorage.getItem("organizationId"),
            actionType: "Collaboration",
            collaborationStatus: doc.isAccepted,
            collaborator: doc.draftUserId,
          };
          const addLogs = await addUserLogs(data1);
          if (addLogs.status !== 200) {
            toast.error(addLogs.message);
          }
          this.setState({
            OGeditor: { ...OGeditor, blocks: cleanedBlocks },
            leftCell: cleanedBlocks,
          });
          setTimeout(() => {
            this.props.history.push({ pathname: "/mydocuments" });
          }, 1000);
        } else {
          toast(data.message);
        }
      }
    });
  };


reactTour = async () => {
    let { leftCell, rightCell } = this.state;
    if (leftCell.length !== rightCell.length) {
      this.setState({ tourChange: true });
    } else {
      for (let i = 0; i < leftCell.length; i++) {
        if (leftCell[i].text !== rightCell[i].text) {
          this.setState({ tourChange: true });
          break;
        }
      }
    }
    this.setState({ reactTour: true });
  };

  handleModalOpen = () => this.setState({ modalOpen: true });
  handleModalClose = () => this.setState({ modalOpen: false });

  // ── Render ──────────────────────────────────────────────────────────────────
  render() {
    let {
      username,
      originalDocument,
      mergeDocuments,
      compareName,
      leftCell,
      rightCell,
      steps1,
      steps2,
      tourChange,
      modalOpen,
      fullscreenMode,
    } = this.state;

    const getGridSizes = () => {
      if (fullscreenMode === "owner")
        return { owner: 12, actions: 0, collaborator: 0 };
      if (fullscreenMode === "collaborator")
        return { owner: 0, actions: 0, collaborator: 12 };
      return { owner: 5, actions: 2, collaborator: 5 };
    };
    const gridSizes = getGridSizes();

    return (
      <Box
        sx={{
          minHeight: "100vh",
          background: COLORS.background.main,
          py: 3,
          px: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <Loader loading={this.state.loading} />
        <ToastContainer />

        <ReactTour
          steps={tourChange ? steps2 : steps1}
          isOpen={this.state.reactTour}
          closeTour={() => this.setState({ reactTour: false })}
        />

        {/* ════════════════════════════════════════════════════════════════
            HEADER
        ════════════════════════════════════════════════════════════════ */}
        <Grid container spacing={2} alignItems="center" sx={{ mb: 4 }}>
          <Grid xs={12} md={8}>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Box>
                <Stack direction="row" alignItems="center" spacing={1}>
                  {/* ── TOUR: back button ── */}
                  <LightTooltip title="Back to My Documents">
                    <IconButton
                      id="tour-back-btn"
                      onClick={this.handleBack}
                      sx={{
                        color: COLORS.text.blue,
                        backgroundColor: alpha(COLORS.primary.main, 0.1),
                        "&:hover": {
                          backgroundColor: alpha(COLORS.primary.main, 0.2),
                        },
                      }}
                    >
                      <ArrowBackIcon />
                    </IconButton>
                  </LightTooltip>

                  <Typography
                    variant="h4"
                    sx={{ color: COLORS.text.blue, fontWeight: 700 }}
                  >
                    Team Collaboration
                  </Typography>
                </Stack>

                <Typography
                  variant="body2"
                  sx={{ color: COLORS.text.secondary }}
                >
                  Compare and merge document changes with collaborators
                </Typography>
              </Box>

              {/* ── TOUR: help button ── */}
              <LightTooltip title="Need Help?">
                <IconButton
                  id="tour-help-btn"
                  onClick={this.reactTour}
                  sx={{
                    color: COLORS.text.blue,
                    backgroundColor: alpha(COLORS.primary.main, 0.1),
                    "&:hover": {
                      backgroundColor: alpha(COLORS.primary.main, 0.2),
                    },
                  }}
                  className="reactour-1"
                >
                  <HelpOutlineIcon />
                </IconButton>
              </LightTooltip>
            </Stack>
          </Grid>

          <Grid
            xs={12}
            md={4}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Stack direction="row" spacing={1} alignItems="center">
              {/* ── TOUR: refresh button ── */}
              <LightTooltip title="Refresh Collaboration">
                <IconButton
                  id="tour-refresh-btn"
                  onClick={this.handleRefresh}
                  sx={{
                    color: COLORS.text.blue,
                    backgroundColor: alpha(COLORS.primary.main, 0.1),
                    "&:hover": {
                      backgroundColor: alpha(COLORS.primary.main, 0.2),
                    },
                  }}
                >
                  <RefreshIcon />
                </IconButton>
              </LightTooltip>

              {/* ── TOUR: collaborators button ── */}
              <Button
                id="tour-collaborators-btn"
                variant="contained"
                startIcon={<GroupsIcon />}
                onClick={this.handleModalOpen}
                sx={{
                  backgroundColor: COLORS.primary.main,
                  color: COLORS.primary.contrast,
                  "&:hover": { backgroundColor: COLORS.primary.dark },
                  borderRadius: "8px",
                  px: 3,
                  py: 1,
                  fontWeight: 600,
                }}
                className="reactour-1"
              >
                {mergeDocuments.length} Collaborator
                {mergeDocuments.length !== 1 ? "s" : ""}
              </Button>
            </Stack>
          </Grid>
        </Grid>

        {/* ════════════════════════════════════════════════════════════════
            DOCUMENT INFO CARD
        ════════════════════════════════════════════════════════════════ */}
        <Card
          id="tour-doc-title-card"
          sx={{
            mb: 4,
            background: COLORS.background.card,
            border: `1px solid ${COLORS.border.light}`,
            borderRadius: "12px",
            boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
          }}
        >
          <Box sx={{ p: 3 }}>
            <Stack
              direction="row"
              alignItems="center"
              spacing={2}
              sx={{ mb: 2 }}
            >
              <CompareArrowsIcon
                sx={{ color: COLORS.text.blue, fontSize: 32 }}
              />
              <Box>
                <Typography
                  variant="h5"
                  sx={{ color: COLORS.text.primary, fontWeight: 600 }}
                >
                  {originalDocument?.documentName}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: COLORS.text.blue, fontWeight: 500 }}
                >
                  Collaborating with{" "}
                  <span style={{ fontWeight: 600 }}>{compareName}</span>
                </Typography>
              </Box>
            </Stack>

            <Stack direction="row" spacing={3} sx={{ mt: 2 }}>
              <Chip
                icon={<PersonIcon />}
                label={`Owner: ${username}`}
                sx={{
                  backgroundColor: alpha(COLORS.primary.main, 0.1),
                  color: COLORS.text.blue,
                  fontWeight: 500,
                  border: `1px solid ${COLORS.primary.medium}`,
                }}
              />
              <Chip
                icon={<GroupsIcon />}
                label={`${mergeDocuments.length} Collaborator${mergeDocuments.length !== 1 ? "s" : ""}`}
                sx={{
                  backgroundColor: alpha(COLORS.secondary.main, 0.1),
                  color: COLORS.secondary.dark,
                  fontWeight: 500,
                  border: `1px solid ${COLORS.secondary.medium}`,
                }}
              />
              <Chip
                label={`${this.state.changeCount} Change${this.state.changeCount !== 1 ? "s" : ""}`}
                sx={{
                  backgroundColor: alpha(COLORS.info.main, 0.1),
                  color: COLORS.info.dark,
                  fontWeight: 600,
                  border: `1px solid ${COLORS.info.medium}`,
                }}
              />
            </Stack>
          </Box>
        </Card>

        {/* ════════════════════════════════════════════════════════════════
            MAIN 3-COLUMN DIFF INTERFACE (normal mode only)
        ════════════════════════════════════════════════════════════════ */}
        {fullscreenMode === null && (
          <Grid container spacing={3}>
            {/* ── OWNER COLUMN ──────────────────────────────────────────── */}
            <Grid xs={12} md={gridSizes.owner}>
              <Card
                id="tour-owner-column"
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  background: COLORS.background.card,
                  border: `1px solid ${COLORS.border.light}`,
                  borderRadius: "12px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                }}
              >
                <Box
                  sx={{
                    p: 2.5,
                    borderBottom: `2px solid ${COLORS.primary.main}`,
                    backgroundColor: alpha(COLORS.primary.light, 0.3),
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: COLORS.primary.main,
                      }}
                    >
                      <Typography
                        sx={{ color: COLORS.primary.contrast, fontWeight: 600 }}
                      >
                        {username?.charAt(0).toUpperCase()}
                      </Typography>
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Typography
                        variant="h6"
                        sx={{ color: COLORS.text.primary, fontWeight: 600 }}
                      >
                        {username}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{ color: COLORS.text.blue }}
                      >
                        Current Document Version
                      </Typography>
                    </Box>
                    <Chip
                      label="Owner"
                      size="small"
                      sx={{
                        backgroundColor: COLORS.primary.main,
                        color: COLORS.primary.contrast,
                        fontWeight: 600,
                      }}
                    />
                  </Stack>

                  {/* ── TOUR: owner fullscreen icon ── */}
                  <LightTooltip title="View fullscreen">
                    <IconButton
                      id="tour-owner-fullscreen"
                      onClick={this.toggleOwnerFullscreen}
                      sx={{
                        color: COLORS.text.blue,
                        backgroundColor: alpha(COLORS.primary.main, 0.1),
                        "&:hover": {
                          backgroundColor: alpha(COLORS.primary.main, 0.2),
                        },
                        ml: 2,
                      }}
                    >
                      <FullscreenIcon />
                    </IconButton>
                  </LightTooltip>
                </Box>

                <Box
                  sx={{
                    p: 2.5,
                    flexGrow: 1,
                    overflow: "auto",
                    backgroundColor: COLORS.background.light,
                  }}
                  className="reactour-2"
                >
                  {leftCell.map((cell, index) => (
                    <Box key={cell.key} sx={{ mb: 2 }}>
                      <Card
                        variant="outlined"
                        sx={{
                          p: 2,
                          borderRadius: "6px",
                          backgroundColor: cell.done
                            ? cell.reject
                              ? alpha(COLORS.error.main, 0.08)
                              : alpha(COLORS.success.main, 0.08)
                            : COLORS.background.card,
                          borderColor: cell.done
                            ? cell.reject
                              ? COLORS.error.medium
                              : COLORS.success.medium
                            : COLORS.border.light,
                          borderWidth: cell.done ? 2 : 1,
                        }}
                      >
                        {cell && (
                          <Diff
                            inputA={cell.text}
                            inputB={rightCell[index]?.text}
                            type="words"
                            color={true}
                            reject={cell.reject || false}
                            successColor={COLORS.success.light}
                            errorColor={COLORS.error.light}
                          />
                        )}
                      </Card>
                    </Box>
                  ))}
                </Box>
              </Card>
            </Grid>

            {/* ── COLLABORATION TOOLS COLUMN ────────────────────────────── */}
            <Grid xs={12} md={gridSizes.actions}>
              <Card
                id="tour-collab-tools"
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  background: COLORS.background.card,
                  border: `2px solid ${COLORS.text.blue}`,
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(25, 118, 210, 0.15)",
                }}
              >
                <Box
                  sx={{
                    p: 2,
                    borderBottom: `1px solid ${COLORS.border.light}`,
                    backgroundColor: alpha(COLORS.text.blue, 0.05),
                  }}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    spacing={1}
                  >
                    <CompareArrowsIcon sx={{ color: COLORS.text.blue }} />
                    <Typography
                      variant="subtitle1"
                      sx={{ color: COLORS.text.blue, fontWeight: 700 }}
                    >
                      Collaboration Tools
                    </Typography>
                  </Stack>
                </Box>

                <Box
                  sx={{
                    p: 2,
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    gap: 2,
                  }}
                >
                  {leftCell.map((cell, index) => (
                    <Box key={cell.key} sx={{ mb: 2 }}>
                      {cell.done ? (
                        /* ── UNDO card ── */
                        <Card
                          sx={{
                            mb: 2,
                            border: `2px solid ${COLORS.actionButtons.undo}`,
                            backgroundColor: alpha(
                              COLORS.actionButtons.undo,
                              0.1,
                            ),
                            borderRadius: "8px",
                          }}
                        >
                          <CardActions sx={{ p: 1, justifyContent: "center" }}>
                            {/* ── TOUR: undo button ── */}
                            <Button
                              id={index === 0 ? "tour-undo-btn" : undefined}
                              size="small"
                              startIcon={<UndoIcon />}
                              onClick={() =>
                                this.undoChange(
                                  cell.key,
                                  rightCell[index]?.text,
                                )
                              }
                              fullWidth
                              sx={{
                                backgroundColor: COLORS.actionButtons.undo,
                                color: "#000000",
                                fontWeight: 600,
                                "&:hover": {
                                  backgroundColor: alpha(
                                    COLORS.actionButtons.undo,
                                    0.9,
                                  ),
                                },
                                borderRadius: "6px",
                                py: 1,
                              }}
                            >
                              Undo Change
                            </Button>
                          </CardActions>
                        </Card>
                      ) : (
                        cell.text !== rightCell[index]?.text && (
                          /* ── ACCEPT / REJECT / MERGE card ── */
                          <Card
                            sx={{
                              mb: 2,
                              border: `1px solid ${COLORS.border.light}`,
                              backgroundColor: COLORS.background.light,
                              borderRadius: "8px",
                            }}
                          >
                            <CardActions
                              sx={{ flexDirection: "column", gap: 1.5, p: 2 }}
                            >
                              {/* ── TOUR: accept button ── */}
                              <Button
                                id={index === 0 ? "tour-accept-btn" : undefined}
                                size="small"
                                startIcon={<CheckCircleOutlineIcon />}
                                onClick={() =>
                                  this.onAccept(
                                    cell.key,
                                    rightCell[index]?.text,
                                  )
                                }
                                sx={{
                                  backgroundColor: COLORS.actionButtons.accept,
                                  color: "#000000",
                                  fontWeight: 600,
                                  "&:hover": {
                                    backgroundColor: alpha(
                                      COLORS.actionButtons.accept,
                                      0.9,
                                    ),
                                  },
                                  borderRadius: "6px",
                                  py: 1,
                                  width: "100%",
                                }}
                                variant="contained"
                                className="reactour-5"
                              >
                                Accept
                              </Button>

                              {/* ── TOUR: reject button ── */}
                              <Button
                                id={index === 0 ? "tour-reject-btn" : undefined}
                                size="small"
                                startIcon={<CancelOutlinedIcon />}
                                onClick={() =>
                                  this.onReject(cell.key, cell.text)
                                }
                                sx={{
                                  backgroundColor: COLORS.actionButtons.reject,
                                  color: "#000000",
                                  fontWeight: 600,
                                  "&:hover": {
                                    backgroundColor: alpha(
                                      COLORS.actionButtons.reject,
                                      0.9,
                                    ),
                                  },
                                  borderRadius: "6px",
                                  py: 1,
                                  width: "100%",
                                }}
                                variant="contained"
                                className="reactour-6"
                              >
                                Reject
                              </Button>

                              {/* ── TOUR: merge button ── */}
                              <Button
                                id={index === 0 ? "tour-merge-btn" : undefined}
                                size="small"
                                startIcon={<MergeIcon />}
                                onClick={() =>
                                  this.onBoth(cell.key, rightCell[index]?.text)
                                }
                                sx={{
                                  backgroundColor: COLORS.actionButtons.merge,
                                  color: "#000000",
                                  fontWeight: 600,
                                  "&:hover": {
                                    backgroundColor: alpha(
                                      COLORS.actionButtons.merge,
                                      0.9,
                                    ),
                                  },
                                  borderRadius: "6px",
                                  py: 1,
                                  width: "100%",
                                }}
                                variant="contained"
                                className="reactour-7"
                              >
                                Merge Both
                              </Button>
                            </CardActions>
                          </Card>
                        )
                      )}
                    </Box>
                  ))}
                </Box>
              </Card>
            </Grid>

            {/* ── COLLABORATOR COLUMN ───────────────────────────────────── */}
            <Grid xs={12} md={gridSizes.collaborator}>
              <Card
                id="tour-collab-column"
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  background: COLORS.background.card,
                  border: `1px solid ${COLORS.border.light}`,
                  borderRadius: "12px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                }}
              >
                <Box
                  sx={{
                    p: 2.5,
                    borderBottom: `2px solid ${COLORS.secondary.main}`,
                    backgroundColor: alpha(COLORS.secondary.light, 0.3),
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: COLORS.secondary.main,
                      }}
                    >
                      <Typography
                        sx={{
                          color: COLORS.secondary.contrast,
                          fontWeight: 600,
                        }}
                      >
                        {compareName?.charAt(0).toUpperCase()}
                      </Typography>
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Typography
                        variant="h6"
                        sx={{ color: COLORS.text.primary, fontWeight: 600 }}
                      >
                        {compareName}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{ color: COLORS.secondary.dark }}
                      >
                        Collaborator's Version
                      </Typography>
                    </Box>
                    <Chip
                      label="Collaborator"
                      size="small"
                      sx={{
                        backgroundColor: COLORS.secondary.main,
                        color: COLORS.secondary.contrast,
                        fontWeight: 600,
                      }}
                    />
                  </Stack>

                  {/* ── TOUR: collaborator fullscreen icon ── */}
                  <LightTooltip title="View fullscreen">
                    <IconButton
                      id="tour-collab-fullscreen"
                      onClick={this.toggleCollaboratorFullscreen}
                      sx={{
                        color: COLORS.secondary.dark,
                        backgroundColor: alpha(COLORS.secondary.main, 0.1),
                        "&:hover": {
                          backgroundColor: alpha(COLORS.secondary.main, 0.2),
                        },
                        ml: 2,
                      }}
                    >
                      <FullscreenIcon />
                    </IconButton>
                  </LightTooltip>
                </Box>

                <Box
                  sx={{
                    p: 2.5,
                    flexGrow: 1,
                    overflow: "auto",
                    backgroundColor: COLORS.background.light,
                  }}
                  className="reactour-3"
                >
                  {rightCell.map((cell, index) => (
                    <Box key={cell.key} sx={{ mb: 2 }}>
                      <Card
                        variant="outlined"
                        sx={{
                          p: 2,
                          borderRadius: "6px",
                          backgroundColor: COLORS.background.card,
                          borderColor: COLORS.border.light,
                        }}
                      >
                        {cell && (
                          <Diff
                            inputA={leftCell[index]?.text}
                            inputB={cell.text}
                            type="chars"
                            color={false}
                            right={true}
                          />
                        )}
                      </Card>
                    </Box>
                  ))}
                </Box>
              </Card>
            </Grid>
          </Grid>
        )}

        {/* ════════════════════════════════════════════════════════════════
            FULLSCREEN — OWNER
        ════════════════════════════════════════════════════════════════ */}
        {fullscreenMode === "owner" && (
          <Box sx={{ mt: 3 }}>
            <Card
              sx={{
                height: "calc(100vh - 200px)",
                display: "flex",
                flexDirection: "column",
                background: COLORS.background.card,
                border: `2px solid ${COLORS.primary.main}`,
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(25, 118, 210, 0.2)",
              }}
            >
              <Box
                sx={{
                  p: 2.5,
                  borderBottom: `2px solid ${COLORS.primary.main}`,
                  backgroundColor: alpha(COLORS.primary.light, 0.3),
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: COLORS.primary.main,
                    }}
                  >
                    <Typography
                      sx={{ color: COLORS.primary.contrast, fontWeight: 600 }}
                    >
                      {username?.charAt(0).toUpperCase()}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      variant="h5"
                      sx={{ color: COLORS.text.primary, fontWeight: 600 }}
                    >
                      {username} - Fullscreen View
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ color: COLORS.text.blue }}
                    >
                      Current Document Version
                    </Typography>
                  </Box>
                  <Chip
                    label="Owner"
                    sx={{
                      backgroundColor: COLORS.primary.main,
                      color: COLORS.primary.contrast,
                      fontWeight: 600,
                    }}
                  />
                </Stack>
                <Stack direction="row" spacing={1}>
                  <LightTooltip title="Exit fullscreen">
                    <IconButton
                      onClick={this.toggleOwnerFullscreen}
                      sx={{
                        color: COLORS.text.blue,
                        backgroundColor: alpha(COLORS.primary.main, 0.1),
                        "&:hover": {
                          backgroundColor: alpha(COLORS.primary.main, 0.2),
                        },
                      }}
                    >
                      <FullscreenExitIcon />
                    </IconButton>
                  </LightTooltip>
                </Stack>
              </Box>
              <Box
                sx={{
                  p: 3,
                  flexGrow: 1,
                  overflow: "auto",
                  backgroundColor: COLORS.background.light,
                }}
              >
                {leftCell.map((cell, index) => (
                  <Box key={cell.key} sx={{ mb: 3 }}>
                    <Card
                      variant="outlined"
                      sx={{
                        p: 3,
                        borderRadius: "8px",
                        backgroundColor: cell.done
                          ? cell.reject
                            ? alpha(COLORS.error.main, 0.08)
                            : alpha(COLORS.success.main, 0.08)
                          : COLORS.background.card,
                        borderColor: cell.done
                          ? cell.reject
                            ? COLORS.error.medium
                            : COLORS.success.medium
                          : COLORS.border.light,
                        borderWidth: cell.done ? 2 : 1,
                      }}
                    >
                      {cell && (
                        <Diff
                          inputA={cell.text}
                          inputB={rightCell[index]?.text}
                          type="words"
                          color={true}
                          reject={cell.reject || false}
                          successColor={COLORS.success.light}
                          errorColor={COLORS.error.light}
                        />
                      )}
                    </Card>
                  </Box>
                ))}
              </Box>
            </Card>
          </Box>
        )}

        {/* ════════════════════════════════════════════════════════════════
            FULLSCREEN — COLLABORATOR
        ════════════════════════════════════════════════════════════════ */}
        {fullscreenMode === "collaborator" && (
          <Box sx={{ mt: 3 }}>
            <Card
              sx={{
                height: "calc(100vh - 200px)",
                display: "flex",
                flexDirection: "column",
                background: COLORS.background.card,
                border: `2px solid ${COLORS.secondary.main}`,
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(156, 39, 176, 0.2)",
              }}
            >
              <Box
                sx={{
                  p: 2.5,
                  borderBottom: `2px solid ${COLORS.secondary.main}`,
                  backgroundColor: alpha(COLORS.secondary.light, 0.3),
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: COLORS.secondary.main,
                    }}
                  >
                    <Typography
                      sx={{ color: COLORS.secondary.contrast, fontWeight: 600 }}
                    >
                      {compareName?.charAt(0).toUpperCase()}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      variant="h5"
                      sx={{ color: COLORS.text.primary, fontWeight: 600 }}
                    >
                      {compareName} - Fullscreen View
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ color: COLORS.secondary.dark }}
                    >
                      Collaborator's Version
                    </Typography>
                  </Box>
                  <Chip
                    label="Collaborator"
                    sx={{
                      backgroundColor: COLORS.secondary.main,
                      color: COLORS.secondary.contrast,
                      fontWeight: 600,
                    }}
                  />
                </Stack>
                <Stack direction="row" spacing={1}>
                  <LightTooltip title="Exit fullscreen">
                    <IconButton
                      onClick={this.toggleCollaboratorFullscreen}
                      sx={{
                        color: COLORS.secondary.dark,
                        backgroundColor: alpha(COLORS.secondary.main, 0.1),
                        "&:hover": {
                          backgroundColor: alpha(COLORS.secondary.main, 0.2),
                        },
                      }}
                    >
                      <FullscreenExitIcon />
                    </IconButton>
                  </LightTooltip>
                </Stack>
              </Box>
              <Box
                sx={{
                  p: 3,
                  flexGrow: 1,
                  overflow: "auto",
                  backgroundColor: COLORS.background.light,
                }}
              >
                {rightCell.map((cell, index) => (
                  <Box key={cell.key} sx={{ mb: 3 }}>
                    <Card
                      variant="outlined"
                      sx={{
                        p: 3,
                        borderRadius: "8px",
                        backgroundColor: COLORS.background.card,
                        borderColor: COLORS.border.light,
                      }}
                    >
                      {cell && (
                        <Diff
                          inputA={leftCell[index]?.text}
                          inputB={cell.text}
                          type="chars"
                          color={false}
                          right={true}
                        />
                      )}
                    </Card>
                  </Box>
                ))}
              </Box>
            </Card>
          </Box>
        )}

        {/* ════════════════════════════════════════════════════════════════
            BOTTOM ACTION BAR (hidden in fullscreen)
        ════════════════════════════════════════════════════════════════ */}
        {fullscreenMode === null && (
          <Card
            sx={{
              mt: 4,
              p: 3,
              background: COLORS.background.card,
              border: `1px solid ${COLORS.border.light}`,
              borderRadius: "12px",
              boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
            }}
          >
            <Stack
              direction={{ xs: "column", md: "row" }}
              spacing={3}
              alignItems="center"
              justifyContent="center"
            >
              {/* ── TOUR: reset button ── */}
              <Button
                id="tour-reset-btn"
                variant="contained"
                startIcon={<RestartAltIcon />}
                onClick={this.resetChanges}
                className={tourChange ? "reactour-8" : "reactour-4"}
                disabled={!this.state.merging}
                sx={{
                  backgroundColor: COLORS.actionButtons.reset,
                  color: "#000000",
                  px: 4,
                  py: 1.5,
                  borderRadius: "8px",
                  fontWeight: 600,
                  "&:hover": {
                    backgroundColor: alpha(COLORS.actionButtons.reset, 0.9),
                  },
                  "&.Mui-disabled": {
                    backgroundColor: alpha(COLORS.text.disabled, 0.3),
                    color: alpha(COLORS.text.disabled, 0.5),
                  },
                }}
              >
                Reset All Changes
              </Button>

              {/* ── TOUR: changes counter chip ── */}
              <Chip
                id="tour-changes-chip"
                label={`${this.state.changeCount} Change${this.state.changeCount !== 1 ? "s" : ""} Pending`}
                sx={{
                  backgroundColor: alpha(COLORS.text.blue, 0.1),
                  color: COLORS.text.blue,
                  border: `2px solid ${COLORS.text.blue}`,
                  fontWeight: 700,
                  fontSize: "1rem",
                  px: 2,
                  py: 2,
                }}
              />

              {/* ── TOUR: complete button ── */}
              <Button
                id="tour-complete-btn"
                variant="contained"
                startIcon={<DoneAllIcon />}
                onClick={this.mergeDocument}
                disabled={!this.state.merging}
                className={tourChange ? "reactour-9" : "reactour-5"}
                sx={{
                  backgroundColor: COLORS.actionButtons.complete,
                  color: "#000000",
                  px: 5,
                  py: 1.5,
                  borderRadius: "8px",
                  fontWeight: 600,
                  fontSize: "1rem",
                  "&:hover": {
                    backgroundColor: alpha(COLORS.actionButtons.complete, 0.9),
                    transform: "translateY(-2px)",
                    boxShadow: `0 4px 12px ${alpha(COLORS.actionButtons.complete, 0.3)}`,
                  },
                  "&.Mui-disabled": {
                    backgroundColor: alpha(COLORS.text.disabled, 0.3),
                    color: alpha(COLORS.text.disabled, 0.5),
                  },
                  transition: "all 0.3s ease",
                }}
              >
                Complete Collaboration
              </Button>
            </Stack>
          </Card>
        )}

        {/* ════════════════════════════════════════════════════════════════
            COLLABORATORS MODAL
        ════════════════════════════════════════════════════════════════ */}
        <Modal
          open={modalOpen}
          onClose={this.handleModalClose}
          aria-labelledby="collaborators-modal"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "90%", sm: 500 },
              bgcolor: COLORS.background.card,
              border: `1px solid ${COLORS.border.light}`,
              boxShadow: "0 10px 40px rgba(0,0,0,0.15)",
              p: 4,
              borderRadius: "12px",
              outline: "none",
            }}
          >
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{ mb: 3 }}
            >
              <Typography
                variant="h5"
                sx={{ color: COLORS.text.primary, fontWeight: 600 }}
              >
                <GroupsIcon
                  sx={{
                    mr: 1,
                    verticalAlign: "middle",
                    color: COLORS.text.blue,
                  }}
                />
                Collaborators ({mergeDocuments.length})
              </Typography>
              <IconButton
                onClick={this.handleModalClose}
                sx={{
                  color: COLORS.text.secondary,
                  "&:hover": { color: COLORS.text.primary },
                }}
              >
                <CloseIcon />
              </IconButton>
            </Stack>

            <Divider sx={{ borderColor: COLORS.border.light, mb: 3 }} />

            <Stack spacing={2}>
              {mergeDocuments.map((doc) => (
                <Card
                  key={doc._id}
                  variant="outlined"
                  sx={{
                    p: 2,
                    backgroundColor: COLORS.background.light,
                    borderColor: COLORS.border.light,
                    borderRadius: "8px",
                    "&:hover": {
                      backgroundColor: alpha(COLORS.primary.main, 0.05),
                      borderColor: COLORS.text.blue,
                      cursor: "pointer",
                    },
                    transition: "all 0.3s ease",
                  }}
                  onClick={() => {
                    this.compareData(doc);
                    this.handleModalClose();
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: COLORS.text.blue,
                      }}
                    >
                      <Typography
                        sx={{ color: COLORS.text.white, fontWeight: 600 }}
                      >
                        {doc.editor.username?.charAt(0).toUpperCase()}
                      </Typography>
                    </Box>
                    <Box sx={{ flexGrow: 1 }}>
                      <Typography
                        variant="subtitle1"
                        sx={{ color: COLORS.text.primary, fontWeight: 500 }}
                      >
                        {doc.editor.username}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{ color: COLORS.text.blue }}
                      >
                        Click to compare versions
                      </Typography>
                    </Box>
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.handleModalClose();
                        this.removeCollaborater(doc);
                      }}
                      sx={{
                        color: COLORS.error.main,
                        backgroundColor: alpha(COLORS.error.main, 0.1),
                        "&:hover": {
                          backgroundColor: alpha(COLORS.error.main, 0.2),
                        },
                      }}
                      title="Remove collaborator"
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Stack>
                </Card>
              ))}
            </Stack>

            <Box sx={{ mt: 4, display: "flex", justifyContent: "flex-end" }}>
              <Button
                onClick={this.handleModalClose}
                variant="outlined"
                sx={{
                  color: COLORS.text.blue,
                  borderColor: COLORS.text.blue,
                  "&:hover": {
                    borderColor: COLORS.primary.dark,
                    color: COLORS.primary.dark,
                    backgroundColor: alpha(COLORS.text.blue, 0.05),
                  },
                }}
              >
                Close
              </Button>
            </Box>
          </Box>
        </Modal>

        {/* ════════════════════════════════════════════════════════════════
            TOUR BOT — floating button + animated panel
        ════════════════════════════════════════════════════════════════ */}
        {this.state.showTeamBot && (
          <TeamCollaborationTourBot
            autoStart={this.state.teamBotAutoStart}
            onAutoStart={() => {
              recordBotGuideAutoOpen(BOT_TYPES.TEAM_COLLAB);
              this.setState({ teamBotAutoStart: false });
            }}
          />
        )}
      </Box>
    );
  }
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
});

export default connect(mapStateToProps)(withRouter(TeamCollaboration));
